import { ConfigProvider, theme } from 'antd'
import * as React from 'react'
import { FC, useLayoutEffect, useRef, useState, PropsWithChildren, cloneElement } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    .ant-table-body {
        scrollbar-width: thin !important;
        scrollbar-color: #eaeaea transparent !important;
        scrollbar-gutter: stable !important;
    }
`

interface TableWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    currentTableHeight?: number
    filtersSummaryHeight?: number
    tableHasNotPagination?: boolean
}

const TableWrapper: FC<PropsWithChildren<TableWrapperProps>> = ({
    children,
    currentTableHeight,
    filtersSummaryHeight = 45,
    tableHasNotPagination = false,
    ...props
}) => {
    const [tableHeight, setTableHeight] = useState(100)
    const ref = useRef<HTMLDivElement>(null)

    useLayoutEffect(() => {
        if (!ref.current) return
        const node = ref.current
        const rect = node.getBoundingClientRect()
        const theadHeight = currentTableHeight ? currentTableHeight : 55
        const paginationHeight = tableHasNotPagination ? 0 : 55
        // const paginationHeight = 28
        // const filtersSummaryHeight = 45
        setTableHeight(rect.height - theadHeight - paginationHeight - filtersSummaryHeight)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref.current])

    return (
        <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
            <Wrapper
                ref={ref}
                {...props}
                style={{ ...props.style, flex: 'auto', overflow: 'hidden' }}
            >
                {/* @ts-ignore */}
                {cloneElement(children, { scroll: { y: tableHeight, x: 'max-content' } })}
            </Wrapper>
        </ConfigProvider>
    )
}

export default TableWrapper
